"use strict";import{tag as o}from"../custom-tag.js";export function unlockedIcon({height:e=16,width:t=16,hidden:l=!1,title:r="Unlocked"}={}){return o`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <path
        fill="currentColor"
        d="M6.553 4.923A5.66 5.66 0 0 1 11.5 2c3.13 0 5.667 2.557 5.667 5.714v2.857H20V22H3V10.571h1.5v.004h6v-.004h3.833V7.714c0-1.7-1.147-2.857-2.833-2.857-1.164 0-2.071.551-2.521 1.452z"
      />
    </svg>
  `}
//# sourceMappingURL=unlocked.js.map
